// Private staff transport. Never subscribe through player or marketing endpoints.
function installation(){
  const k='department-push-installation';
  let id=localStorage.getItem(k);
  if(!id){id=crypto.randomUUID();localStorage.setItem(k,id);}
  return id;
}

export async function configureDepartmentPush(client,finance,enabled,interactive=false,nativeToken){
  const api=finance?'/api/finance/department-push/device':'/api/admin/finance-chat/device';
  const payload={enabled,installation:installation()};
  if(!enabled){await client.post(api,payload);return;}
  const bridge=!finance&&window.AndroidStaffChat;
  const path=location.pathname.replace(/(\/admin)(?:\/.*)?$/,'$1/chat');
  payload.path=finance?'/finance':/^\/(?:[\w-]+\/)?admin\/chat$/.test(path)?path:'/admin/chat';
  if(bridge?.getFcmToken){
    if(interactive)bridge.requestNotifications?.();
    if(bridge.notificationsEnabled&&!bridge.notificationsEnabled()){
      if(interactive)for(let i=0;i<10&&!bridge.notificationsEnabled();i++)await new Promise(r=>setTimeout(r,400));
      if(!bridge.notificationsEnabled())throw Error('Allow WhiteRoom notifications in device settings, then retry.');
    }
    let token=nativeToken||bridge.getFcmToken();
    if(!token){
      bridge.refreshFcmToken?.();
      for(let i=0;i<5&&!token;i++){await new Promise(r=>setTimeout(r,450));token=bridge.getFcmToken();}
    }
    if(!token)throw Error('WhiteRoom has no push token yet. Check notification permission and retry.');
    payload.token=token;
  }else{
    if(!window.isSecureContext||!navigator.serviceWorker||!window.PushManager||!window.Notification)
      throw Error('Background push is unavailable in this browser. On iPhone, open the installed Home Screen app.');
    if(interactive&&window.Notification.permission==='default')await window.Notification.requestPermission();
    if(window.Notification.permission!=='granted')throw Error('Allow notifications for this site in device settings, then retry.');
    await navigator.serviceWorker.register('/sw.js');
    const reg=await Promise.race([navigator.serviceWorker.ready,new Promise((_,reject)=>setTimeout(()=>reject(Error('Push service is not ready. Retry.')),10000))]);
    const {data}=await client.get('/api/push/vapid-key');
    const key=data.public_key;if(!key)throw Error('Browser push is not configured on this server.');
    const bytes=Uint8Array.from(atob(key.replace(/-/g,'+').replace(/_/g,'/')),v=>v.charCodeAt(0));
    const existing=await reg.pushManager.getSubscription();
    if(existing?.options?.applicationServerKey){
      const old=new Uint8Array(existing.options.applicationServerKey);
      if(bytes.length!==old.length||!bytes.every((v,i)=>v===old[i]))throw Error('This device uses a different push key. Contact support.');
    }
    const sub=existing||await reg.pushManager.subscribe({userVisibleOnly:true,applicationServerKey:bytes});
    const json=sub.toJSON();Object.assign(payload,{endpoint:json.endpoint,p256dh:json.keys.p256dh,auth:json.keys.auth});
  }
  await client.post(api,payload);
}
